// @ts-strict-ignore
import React from 'react';

import { PublicPage } from 'api/website';
import { Box } from 'components/Box';
import { SocialIcon } from 'components/Icon/Social';
import { SocialButton } from 'components/SocialButton';

type Props = {
  content: PublicPage;
  message: string | null | undefined;
  title: string;
  subsite: string;
};

export function CmsSocialButtons({ content, message, title, subsite }: Props) {
  return (
    <>
      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="facebook"
        utmParams={{}}
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      >
        <Box
          width={32}
          height={32}
          classes={['flex', 'justify-center', 'align-center']}
        >
          <SocialIcon
            name="facebook"
            width={14}
            height={14}
            fill="currentColor"
          />
        </Box>
      </SocialButton>

      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="twitter"
        utmParams={{}}
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      >
        <Box
          width={32}
          height={32}
          classes={['flex', 'justify-center', 'align-center']}
        >
          <SocialIcon
            name="twitter"
            width={14}
            height={14}
            fill="currentColor"
          />
        </Box>
      </SocialButton>

      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="linkedin"
        utmParams={{}}
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      >
        <Box
          width={32}
          height={32}
          classes={['flex', 'justify-center', 'align-center']}
        >
          <SocialIcon
            name="linkedin"
            width={14}
            height={14}
            fill="currentColor"
          />
        </Box>
      </SocialButton>
    </>
  );
}
